import { styled } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const StyledForgotPasswordLink = styled(NavLink)(({ theme }) => ({
  marginTop: theme.spacing(6),
  width: '100%',
  display: 'block',
  '& .forgot-link': {
    color: theme.colors?.primary.parchment,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
}));
